<section class="audio-player" [hidden]="!file">
  <video id="audio-file"
         #audioFileElement
         class="video-js"
         controls
         [poster]="poster"
         preload="none">
    <p class="vjs-no-js">
      To view this video please enable JavaScript, and consider upgrading to a web browser that
      <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
    </p>
  </video>
  <div class="message-wrapper" [ngClass]="{'hide' : !videoMessage.show, 'hide-loader': !videoMessage.loader}">
    <div class="vjs-loading-spinner" dir="ltr"></div>
    <span class="message">
      {{videoMessage.message}}
    </span>
  </div>
</section>
